import React, { Component } from "react";

import CallApi from "../../utils/CallApi";
import PropTypes from "prop-types";

import InfoIcon from "@material-ui/icons/Info";
import { Localized } from "fluent-react/compat";
import ChoiceCurrency from "./ChoiceCurrency";
import SnackBar from "../user/SnackBar";
import Button from "./Button";

const SLITE_SLOT_DOC_URL =
  "https://laddition.slite.page/p/hbFPkc2XQLbema/Gestion-des-creneaux-horaires";

// seules ces durees sont acceptees, cote formulaire comme cote API
// (15 a 60 minutes, par tranche de 15)
const SLOT_DURATIONS = [15, 30, 45, 60];
const DEFAULT_SLOT_DURATION = 15;
const SLOT_MAX_COUNT_MIN = 1;
const SLOT_MAX_COUNT_MAX = 999;

const isSlotMaxCountValid = (value) =>
  value !== "" &&
  Number.isInteger(Number(value)) &&
  Number(value) >= SLOT_MAX_COUNT_MIN &&
  Number(value) <= SLOT_MAX_COUNT_MAX;

class Logistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restaurantId: props.restaurantId,
      currencies: props.currencies,
      currency: props.currency,
      success: false,
      errors: "",
      timePrepare: props.timePrepareOrder,
      typeValidation: props.automaticallyValidated
        ? "validated"
        : "to_validate",
      disabledSubmit: false,
      openSnack: false,
      errorUpdate: false,
      orderShiftClose: props.orderShiftClose,
      slotAuto: !!props.slotAuto,
      slotDuration: SLOT_DURATIONS.includes(Number(props.slotDuration))
        ? Number(props.slotDuration)
        : DEFAULT_SLOT_DURATION,
      // data deduit le mode de la colonne renseignee, "commandes" primant
      slotMaxMode: Number(props.slotMaxProductsCount) > 0 ? "products" : "order",
      slotMaxCount:
        Number(props.slotMaxOrderCount) ||
        Number(props.slotMaxProductsCount) ||
        "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOrderChange = this.handleOrderChange.bind(this);
    this.handleSlotAutoChange = this.handleSlotAutoChange.bind(this);
    this.handleSlotDurationChange = this.handleSlotDurationChange.bind(this);
    this.handleSlotMaxModeChange = this.handleSlotMaxModeChange.bind(this);
    this.handleSlotMaxCountChange = this.handleSlotMaxCountChange.bind(this);
    this.handleCurrency = this.handleCurrency.bind(this);
    this.findCurrency = this.findCurrency.bind(this);
  }

  handleInputChange(e) {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({ [name]: value }, () => this.checkInputs());
  }

  handleOrderChange(e) {
    this.setState({
      orderShiftClose: this.state.orderShiftClose == true ? false : true,
    });
  }

  handleSlotAutoChange(e) {
    this.setState({ slotAuto: e.target.checked }, () => this.checkInputs());
  }

  handleSlotDurationChange(e) {
    this.setState({ slotDuration: Number(e.target.value) });
  }

  handleSlotMaxModeChange(e) {
    this.setState({ slotMaxMode: e.target.value });
  }

  handleSlotMaxCountChange(e) {
    const { value } = e.target;
    this.setState({ slotMaxCount: value === "" ? "" : Number(value) }, () =>
      this.checkInputs()
    );
  }

  handleCurrency(slctCurrency) {
    this.setState({ currency: slctCurrency });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const {
      typeValidation,
      timePrepare,
      currency,
      orderShiftClose,
      slotAuto,
      slotDuration,
      slotMaxMode,
      slotMaxCount,
    } = this.state;
    const idCurrencyToSend = this.findCurrency();
    const Validation = {
      update: "logistics",
      automatically_validated: typeValidation === "validated" ? 1 : 0,
      time_prepare: timePrepare,
      id_currency: idCurrencyToSend,
      currency,
      order_shift_close: orderShiftClose ? 1 : 0,
      slot_auto: slotAuto ? 1 : 0,
      slot_duration: slotDuration,
    };
    // sans plafond saisi on n'envoie rien : l'API conserve l'etat en base
    if (isSlotMaxCountValid(slotMaxCount)) {
      Validation.slot_max_mode = slotMaxMode;
      Validation.slot_max_count = Number(slotMaxCount);
    }

    try {
      const result = await CallApi(
        "PUT",
        "restaurant/admin/info",
        this.props.restaurantId,
        Validation,
        this.props.token
      );

      if (result && result[0].success) {
        this.setState(
          {
            openSnack: true,
            errorUpdate: false,
          },
          () => {
            setTimeout(() => this.props.onUpdateLogistics(Validation), 1800);
          }
        );
      }
    } catch (e) {
      this.setState({
        errorUpdate: true,
        openSnack: true,
      });
    }
  };

  handleCloseSnack = () => {
    this.setState({ openSnack: false });
  };

  findCurrency() {
    const { currencies, currency } = this.state;
    const resultCurrency = currencies.find(
      (curr) => curr.currency === currency
    );
    return resultCurrency.id;
  }

  checkInputs = () => {
    const { typeValidation, timePrepare, slotAuto, slotMaxCount } = this.state;
    if (slotAuto && !isSlotMaxCountValid(slotMaxCount)) {
      return this.setState({ disabledSubmit: true });
    }
    const getNumberStreetRegex = /^[0-9]*$/;
    const check =
      typeValidation &&
      timePrepare.match(getNumberStreetRegex) &&
      timePrepare &&
      Number(timePrepare) >= 10 &&
      Number(timePrepare) <= 90
        ? false
        : true;

    this.setState({ disabledSubmit: check });
  };

  render() {
    const {
      typeValidation,
      disabledSubmit,
      errorUpdate,
      timePrepare,
      currency,
      orderShiftClose,
      slotAuto,
      slotDuration,
      slotMaxMode,
      slotMaxCount,
    } = this.state;
    const snackText = !errorUpdate ? (
      <Localized id="tr-admin-change-save" />
    ) : (
      <Localized id="tr-admin-change-error" />
    );
    const success = !errorUpdate;
    return (
      <div id="logistics" className="container">
        <form className="pure-form pure-form-stacked">
          <h3>
            <Localized id="tr-admin-how-order-delivered" />
          </h3>
          <label htmlFor="manually">
            <input
              id="manually"
              type="radio"
              name="typeValidation"
              value="validated"
              checked={typeValidation === "validated" ? true : false}
              onChange={this.handleInputChange}
            />
            <span>
              <Localized id="tr-admin-automatically-validation" />
            </span>
          </label>
          <label htmlFor="automatically">
            <input
              id="automatically"
              type="radio"
              name="typeValidation"
              value="to_validate"
              checked={typeValidation === "to_validate" ? true : false}
              onChange={this.handleInputChange}
            />
            <span>
              <Localized id="tr-admin-manually-validation" />
            </span>
          </label>
          <h3>
            <Localized id="tr-admin-order-before-shift-open" />
          </h3>
          <p>
            <Localized id="tr-admin-order-before-shift-open-desc" />
          </p>
          <label htmlFor="orderShiftCloseInput">
            <input
              id="orderShiftCloseInput"
              type="radio"
              checked={orderShiftClose == true}
              onClick={this.handleOrderChange}
            />
            <span>
              <Localized id="tr-admin-order-before-shift-open-input" />
            </span>
          </label>

          <h3>
            <Localized id="tr-admin-slot-management" />
            <Localized id="tr-admin-slot-help" attrs={{ title: true }}>
              <a
                href={SLITE_SLOT_DOC_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="slot-help-link"
                title=""
              >
                <InfoIcon fontSize="small" color="primary" />
              </a>
            </Localized>
          </h3>
          <div className="slot-management">
            <label className="slot-checkbox" htmlFor="slotAutoInput">
              <input
                id="slotAutoInput"
                type="checkbox"
                name="slotAuto"
                checked={slotAuto}
                onChange={this.handleSlotAutoChange}
              />
              <span>
                <Localized id="tr-admin-slot-auto" />
              </span>
            </label>

            <div className="slot-field">
              <label htmlFor="slotDurationInput">
                <Localized id="tr-admin-slot-duration" />
              </label>
              <select
                id="slotDurationInput"
                className="slot-select"
                name="slotDuration"
                value={slotDuration}
                onChange={this.handleSlotDurationChange}
              >
                {SLOT_DURATIONS.map((duration) => (
                  <Localized
                    key={duration}
                    id="tr-admin-slot-duration-unit"
                    $minutes={duration}
                  >
                    <option value={duration}>{`${duration} minutes`}</option>
                  </Localized>
                ))}
              </select>
            </div>

            <div className="slot-field">
              <p className="slot-field-title">
                <Localized id="tr-admin-slot-max-mode" />
              </p>
              <label htmlFor="slotMaxModeOrder">
                <input
                  id="slotMaxModeOrder"
                  type="radio"
                  name="slotMaxMode"
                  value="order"
                  checked={slotMaxMode === "order"}
                  onChange={this.handleSlotMaxModeChange}
                />
                <span>
                  <Localized id="tr-admin-slot-max-orders" />
                </span>
              </label>
              <p className="slot-sublabel">
                <Localized id="tr-admin-slot-max-orders-help" />
              </p>
              <label htmlFor="slotMaxModeProducts">
                <input
                  id="slotMaxModeProducts"
                  type="radio"
                  name="slotMaxMode"
                  value="products"
                  checked={slotMaxMode === "products"}
                  onChange={this.handleSlotMaxModeChange}
                />
                <span>
                  <Localized id="tr-admin-slot-max-products" />
                </span>
              </label>
              <p className="slot-sublabel">
                <Localized id="tr-admin-slot-max-products-help" />
              </p>
              <p className="slot-sublabel">
                <Localized id="tr-admin-slot-max-products-help-levels" />
              </p>
            </div>

            <div className="slot-field">
              <label htmlFor="slotMaxCountInput">
                <Localized
                  id="tr-admin-slot-max-count"
                  $mode={slotMaxMode}
                  $minutes={slotDuration}
                />
              </label>
              <input
                id="slotMaxCountInput"
                className="slot-max-count"
                type="number"
                name="slotMaxCount"
                min={SLOT_MAX_COUNT_MIN}
                max={SLOT_MAX_COUNT_MAX}
                value={slotMaxCount}
                onChange={this.handleSlotMaxCountChange}
              />
              {slotAuto && !isSlotMaxCountValid(slotMaxCount) ? (
                <p className="slot-error">
                  <Localized id="tr-admin-slot-max-required" />
                </p>
              ) : null}
            </div>
          </div>

          <h3>
            <Localized id="tr-admin-how-long-prepare-order" />
          </h3>
          <p>
            A noter que votre temps de préparation influencera vos heures
            disponibles de retrait.
          </p>
          <p>
            Heure de retrait + temps de préparation = heures disponibles de
            retrait
          </p>
          <p>20h30 + 30 min de préparation = 21h dernière heure de retrait</p>
          <label htmlFor="tentacles">
            <Localized id="tr-admin-label-prepare-order" />
          </label>
          <input
            type="number"
            name="timePrepare"
            min="10"
            max="90"
            value={timePrepare}
            className="time-prepare-order"
            onChange={this.handleInputChange}
            required
          />
          <SnackBar
            open={this.state.openSnack}
            handleCloseSnack={this.handleCloseSnack}
            text={snackText}
            success={success}
          />
          <ChoiceCurrency
            handleCurrency={this.handleCurrency}
            currency={currency}
          />
          <Button
            disabledSubmit={disabledSubmit}
            submit={this.handleSubmit}
            text={"tr-button-validate"}
            classCusto={"is-red"}
          />
        </form>
      </div>
    );
  }

  static defaultProps = {
    restaurantId: "1",
    deliverySettings: {
      active: false,
      minimum_amount: 0,
      surcharge: 0,
      free_surcharge: 0,
    },
    takeAwaySettings: { active: false, minimum_amount: 0, surcharge: 0 },
    country: "FR",
  };
}

Logistics.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  slotAuto: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  slotDuration: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  slotMaxOrderCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  slotMaxProductsCount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  deliveryArea: PropTypes.array,
  country: PropTypes.string,
  onUpdateLogistics: PropTypes.func,
  deliveryActive: PropTypes.bool,
  deliveryMin: PropTypes.number,
  deliverySup: PropTypes.number,
  deliveryFreeSurcharge: PropTypes.number,
  takeAwayActive: PropTypes.bool,
  takeAwayMin: PropTypes.number,
  takeAwaySup: PropTypes.number,
};

export default Logistics;
